export const competitionRoutes = {
	children: [{
		children: [{
			component: () => import(`@/view/competition/Competition.vue`),
			name: `Competition`,
			path: ``
		}, {
			component: () => import(`@/view/competition/Address.vue`),
			name: `CompetitionAddress`,
			path: `address`
		}, {
			component: () => import(`@/view/competition/CreateDocument.vue`),
			meta: { hasRole: [ `club:admin` ] },
			name: `CreateCompetitionDocument`,
			path: `document/create`
		}, {
			component: () => import(`@/view/competition/CreateEvent.vue`),
			meta: { hasRole: [ `club:admin` ] },
			name: `CreateCompetitionEvent`,
			path: `event/create`
		}, {
			component: () => import(`@/view/competition/CreateFee.vue`),
			meta: { hasRole: [ `club:admin` ] },
			name: `CreateCompetitionFee`,
			path: `fee/create`
		}, {
			component: () => import(`@/view/competition/CreateProduct.vue`),
			meta: { hasRole: [ `club:admin` ] },
			name: `CreateCompetitionProduct`,
			path: `product/create`
		}, {
			component: () => import(`@/view/competition/Edit.vue`),
			meta: { hasRole: [ `club:admin` ] },
			name: `EditCompetition`,
			path: `edit`
		}],
		component: () => import(`@/view/Blank.vue`),
		path: `:competitionId`
	}, {
		component: () => import(`@/view/competition/Create.vue`),
		meta: { hasRole: [ `club:admin` ] },
		name: `CreateCompetition`,
		path: `club/:clubId/create`
	}],
	component: () => import(`@/view/OneSidebar.vue`),
	path: `/competition`
};
